"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformColorToString = transformColorToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformColorToString(color) {
    switch (color) {
        case legacy_enums_1.Color.Black:
            return "black";
        case legacy_enums_1.Color.LowBlue:
            return "low blue";
        case legacy_enums_1.Color.LowGreen:
            return "low green";
        case legacy_enums_1.Color.LowCyan:
            return "low cyan";
        case legacy_enums_1.Color.LowRed:
            return "low red";
        case legacy_enums_1.Color.LowMagenta:
            return "low magenta";
        case legacy_enums_1.Color.Brown:
            return "brown";
        case legacy_enums_1.Color.LightGray:
            return "light gray";
        case legacy_enums_1.Color.DarkGray:
            return "dark gray";
        case legacy_enums_1.Color.HighBlue:
            return "high blue";
        case legacy_enums_1.Color.HighGreen:
            return "high green";
        case legacy_enums_1.Color.HighCyan:
            return "high cyan";
        case legacy_enums_1.Color.HighRed:
            return "high red";
        case legacy_enums_1.Color.HighMagenta:
            return "high magenta";
        case legacy_enums_1.Color.Yellow:
            return "yellow";
        case legacy_enums_1.Color.White:
            return "white";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformColorToString.js.map